var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2390_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1666 26.75H102.542V35.6667H98.0832V84.7083H102.542V93.625H4.45825V84.7083H8.91658V35.6667H4.45825V26.75H17.8333V17.8333C17.8333 16.6509 18.303 15.5169 19.1391 14.6808C19.9752 13.8447 21.1092 13.375 22.2916 13.375H84.7082C85.8907 13.375 87.0247 13.8447 87.8608 14.6808C88.6969 15.5169 89.1666 16.6509 89.1666 17.8333V26.75ZM89.1666 35.6667H17.8333V84.7083H31.2083V53.5H40.1249V84.7083H49.0416V53.5H57.9582V84.7083H66.8749V53.5H75.7916V84.7083H89.1666V35.6667ZM26.7499 22.2917V26.75H80.2499V22.2917H26.7499Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2390_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.2d81fbdf34b00a393c6c74058447a03f.svg";
export { ForwardRef as ReactComponent };